export var HandlerType;
(function (HandlerType) {
    HandlerType["SCALAR"] = "Scalar";
    HandlerType["ANGLE"] = "Angle";
    HandlerType["VECTOR"] = "Vector";
    HandlerType["LEVEL"] = "Level";
    // POWER_REGRESSION = 'PowerRegression',
    // NUMBER_MAP = 'NumberMap',
    // SCALABLE_SCALAR = 'ScalableScalar'
})(HandlerType || (HandlerType = {}));
